var _rect, _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#454851"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 23.9999C33.7504 25.6832 33.3149 27.338 32.486 28.803C31.6572 30.2681 30.4631 31.4937 29.02 32.3604C27.577 33.2271 25.9341 33.7054 24.2514 33.7488C22.5686 33.7922 20.9033 33.3992 19.4175 32.608L16.2253 33.6721C15.961 33.7602 15.6774 33.773 15.4062 33.709C15.1351 33.645 14.8871 33.5068 14.6901 33.3098C14.4931 33.1128 14.3549 32.8648 14.2909 32.5937C14.2269 32.3225 14.2397 32.0389 14.3278 31.7746L15.3919 28.5824C14.6964 27.2748 14.3079 25.826 14.256 24.3458C14.2041 22.8657 14.49 21.3932 15.0921 20.04C15.6942 18.6869 16.5967 17.4887 17.731 16.5365C18.8654 15.5842 20.2017 14.9029 21.6387 14.5442C23.0756 14.1855 24.5754 14.1589 26.0242 14.4663C27.473 14.7738 28.8327 15.4073 30.0001 16.3188C31.1675 17.2302 32.1119 18.3956 32.7616 19.7265C33.4114 21.0574 33.7494 22.5189 33.75 23.9999Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 18,
    r: 5,
    fill: "#454851"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 18,
    r: 3,
    fill: "#AF935D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.e3d0f84afe526f9e95dfc47c71d6de00.svg";
export { ForwardRef as ReactComponent };